export default __webpack_public_path__ + "static/media/2.d6231b97.png";